import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';


@Injectable()
export class SurveyProvider{

  URL = environment.surveyUrl;
  public answerMaster : Map<number, any> = new Map<number, any>();

  constructor(public http: HttpClient, private storage: Storage) {}

  getAnswerType(id: number){
    return this.answerMaster.get(id);
  }
  
  getAnswerMaster(){
    return this.getToken().then((val) => {
      if(this.answerMaster.size > 0){
        return Promise.resolve(this.answerMaster);
      }
      if(val){
        return this.http.get<any>(this.getUrl(`/v1/society/${val.societyId}/answermasters`,val))
        .toPromise().then(val => {
          val.data.forEach(val => {
            this.answerMaster.set(val.id, val);
          });
          return Promise.resolve(this.answerMaster);
        });
      }
    });    
  }

  getActiveSurvey(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<any[]>(this.getUrl(`/v1/society/${val.societyId}/getactivesurvey`,val)+`&is_vacant=${val.is_vacant}`)
        .toPromise();
      }
    });
  }

  getQuestions(id){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<any[]>(this.getUrl(`/v1/society/${val.societyId}/getquestionbysurvey`,val)+`&survey_id=${id}`)
        .toPromise();
      }
    });
  }

  submitSurvey(data){
    return this.getToken().then((val) => {
      data.forEach(d => {
        d.society_id = val.societyId;
        d.unit_no = val.id;
        d.email = (val.email)?val.email:null;
        d.created_at = (new Date()).toISOString();
        d.updated_at = (new Date()).toISOString();
      });
      if(val){
        return this.http.post<any>(this.getUrl(`/v1/society/${val.societyId}/sendsurveyresult`,val) +`&unit_no=${val.flat_no}`, {
          arr: data
        })
        .toPromise();
      }
    });
  }

  editSurvey(data){
    return this.getToken().then((val) => {
      if(val){
        return this.http.put<any>(this.getUrl(`/v1/society/${val.societyId}/editsurveyresult`,val) +`&unit_no=${val.flat_no}`, {
          arr: data
        } )
        .toPromise();
      }
    });
  }

  getSurvey(id){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<any[]>(this.getUrl(`/v1/society/${val.societyId}/getsurveyresultsbyunitno`,val)+`&survey_id=${id}&unit_no=${val.id}`)
        .toPromise();
      }
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(link: string, val: any):string {
    console.log(val,"hello Provider")
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}&tenant=${val.tenant}&role=${val.role}`;
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}



// WEBPACK FOOTER //
// ./src/providers/survey/survey.ts